<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-data-iterator
            :items="items"
            hide-default-footer
        >
            <template v-slot:header>
                <v-toolbar
                    class="mb-2"
                    color="indigo darken-5"
                    dark
                    flat
                >
                    <v-toolbar-title>基础设置</v-toolbar-title>
                </v-toolbar>
            </template>

            <template v-slot:default="props">
                <v-row>
                    <v-col
                        v-for="item in props.items"
                        :key="item.id"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                    >
                        <v-card>
                            <v-card-title class="subheading font-weight-bold">
                                {{ item.note }}
                            </v-card-title>

                            <v-divider></v-divider>
                            <v-list dense>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-textarea
                                            :label="$vuetify.lang.t('$vuetify.custom.necessary')"
                                            v-model="item.v"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-card-actions>
                                <v-row justify="end">
                                    <v-btn color="success" class="mr-5" @click="updateItem(item)" dark large>
                                        <v-icon left>mdi-update</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.updateBtn') }}
                                    </v-btn>
                                </v-row>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:footer>
                <v-toolbar
                    class="mt-2"
                    color="indigo"
                    dark
                    flat
                >
                    <v-toolbar-title class="subheading"></v-toolbar-title>
                </v-toolbar>
            </template>
        </v-data-iterator>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay:false,
            items: [
            ],
            regexp: /^[1-9]+[0-9]*$/,
        }

    },
    mounted(){
        this.initialize()
    },
    methods: {
        updateItem(item){
            this.$dialog.confirm('确定要修改吗','', () => {
                if(item.k ==="target" || item.k ==="readmin"){
                    if(!this.regexp.test(item.v)){
                        this.$dialog.alert("请填写正整数")
                        this.initialize()
                        return
                    }
                }
                this.overlay = true
                this.$api.sysSetting.updateSetting({k:item.k,v:item.v}).then(data => {
                    this.overlay = false
                    if (data.flag) {
                        this.initialize()
                        this.$dialog.alert("修改成功")
                    }else {
                        if(!data.flag){
                            this.$dialog.alert(data.msg)
                        }
                    }
                })
            })
        },
        initialize() {
            this.$api.sysSetting.selectAll().then(data => {
                if (data.data) {
                    this.items = data.data;
                }else {
                    if(!data.flag){
                        this.$dialog.alert(data.msg)
                    }
                }
            })
        },
    },
    components: {
    },
}
</script>
<style></style>

